export default __webpack_public_path__ + "static/media/closer-mystery.686099b9.mp3";